module.exports = __webpack_public_path__ + "static/31-img-1-d9ab7ec6e841b5ae3cbfb7147b40ed3f.png";